import {unwrap} from '@pocketbuy/outdoor-api-client';
import type {StaffRole} from '@pocketbuy/outdoor-business-types';
import {client} from '../../api';

export const performanceRoles: StaffRole[] = ['DIRECTOR','DEPUTY_REGIONAL_MANAGER','BUSINESS_MANAGER','BUSINESS_EXECUTIVE','CLUSTER_LEADER','SALES_AGENT'];
export type Period = 'TODAY' | 'YESTERDAY' | 'THIS_WEEK' | 'LAST_WEEK' | 'THIS_MONTH' | 'LAST_MONTH';
export const canViewLeaderboard = (role?: StaffRole) => role === 'DIRECTOR' || role === 'DEPUTY_REGIONAL_MANAGER';
export type View = 'TEAM' | 'LEADERBOARD';
export type Counts = {completedOrders: number; activeAgents: number | null; productiveAgents: number | null};
export type Choice = {code: string; label: string};
export type PerformanceRow = {scope: string; name: string; context: string; metrics: Counts; rank: number | null; self: boolean; canDrill: boolean; previousMember: boolean};
export type PerformancePageData = {
  state: 'READY' | 'STALE' | 'PREPARING' | 'UPDATING' | 'UNAVAILABLE' | 'VERSION_EXPIRED' | 'NO_SCOPE';
  period: Period; view: View; scope: string; title: string; context: string; group: string;
  comparison: string; comparisonName: string; dataAsOf: string; periodStart: string; periodEnd: string; snapshot: string; timeZone: string;
  teamMetrics: boolean; pollSeconds: number; metrics: Counts | null; self: PerformanceRow | null;
  groups: Choice[]; comparisons: Choice[]; workAreas: Choice[]; items: PerformanceRow[]; nextCursor: number | null; total: number;
};
export type PerformanceRequest = {period: Period; view: View; scope: string; group: string; comparison: string; snapshot: string; q: string};
export const performanceApi = {
  get: (params: PerformanceRequest & {after?: number}, signal?: AbortSignal) =>
    unwrap<PerformancePageData>(client.get('/v1/performance', {params, signal})),
};
export const periodOptions: Choice[] = [
  {code:'TODAY',label:'Today'}, {code:'YESTERDAY',label:'Yesterday'},
  {code:'THIS_WEEK',label:'This week'}, {code:'LAST_WEEK',label:'Last week'},
  {code:'THIS_MONTH',label:'This month'}, {code:'LAST_MONTH',label:'Last month'},
];
export function dateRange(start: string, end: string) {
  const format = (value: string) => new Intl.DateTimeFormat('en-GB', {day:'numeric',month:'short',year:'numeric',timeZone:'UTC'}).format(new Date(`${value}T00:00:00Z`));
  return start === end ? format(start) : `${format(start)} – ${format(end)}`;
}
export function visibleRows(pages: PerformancePageData[]) {
  const first = pages[0];
  if (!first?.metrics) return [];
  // A failed/expired later page must never mix versions or turn an error into an empty list.
  const seen = new Set<string>();
  return pages.filter(page => page.snapshot === first.snapshot).flatMap(page => page.items).filter(row => {
    if (seen.has(row.scope)) return false;
    seen.add(row.scope); return true;
  });
}
